import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import createReportFiltersetFn from "ApiLayer/Measures/queryCreateReportFilterset";

export const usePropertyFilterset = (propertyUid: string | undefined) => {
    const accessToken = useAccessToken();
    return useQuery({
        queryKey: ["propertyFilterset", propertyUid],
        queryFn: () =>
            createReportFiltersetFn(accessToken, {
                booleanFilters: [
                    { condition: "TRUE" as BooleanFilterCondition, field: "is_reported" as BooleanFilterField },
                ],
                dataCoverageFilter: [],
                dateFilters: [],
                numericFilters: [],
                stringFilters: [
                    {
                        field: "property_uid" as StringFilterField,
                        condition: "equal" as StringFilterCondition,
                        value: [propertyUid!],
                        key: "",
                    },
                ],
            }),
        enabled: !!propertyUid,
        staleTime: Infinity,
    });
};
